// @autogenerated

// WARNING THIS FILE IS AUTOGENERATED! DO NOT EDIT!

// Developer note: these files are treated as templates and called from prebuild.js
// They shouldn't be imported and used directly.

import React from 'react';
import { Link } from 'gatsby';
import onChangeGenerator from '../../commons/onChangeGenerator';
import P from '@govtnz/ds/build/react-ts/P';
import '../../commons/styles/ds/themed-P.scss';
import A from '@govtnz/ds/build/react-ts/A';
import '../../commons/styles/ds/themed-A.scss';

// Indirect relative import because this template is output to src/pages/components so it needs to step back to `commons`.
import ComponentPage from '../../commons/component-page';
import ComponentCode from '../../commons/component-code';
import Example from '../../commons/Example';
import ExampleContainer from '../../commons/ExampleContainer';
import ExampleHeading from '../../commons/ExampleHeading';
import ExampleSection from '../../commons/ExampleSection';
import MainNavMobileMenuContext from '../../commons/MainNavMobileMenuContext';
import '../../commons/styles/ds/themed-Button.scss';
import '../../commons/styles/ds/themed-CaptionL.scss';

const PageContent = (props) => <React.Fragment><P>As key building blocks of the New Zealand Government Design System (NZGDS), our components are designed and coded to solve specific user problems.</P>
<P>Choose what you need from our catalogue of modular components. Using them saves you the time and cost of developing and testing complex components yourself. Designed to integrate directly into existing content management systems, these components will add functionality to your website without you having to rebuild it.</P>
<P>Browse available components via the sidebar menu if you’re on a desktop, or the main menu if you’re using a mobile.</P>
</React.Fragment>

export default function Code(props) {
  return (
    <ComponentPage
      title={"index"}
      id={"index"}
      pageProps={props}
      PageContent={PageContent}
    />
  );
}
